import { Badge } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import dayjs from 'dayjs';

// Kalendertag mit Badge (Anzahl Termine) und Sperre für vergangene Tage.
function ServerDay(props) {
    const { day, outsideCurrentMonth, termine = [], ...other } = props;
    const dateStr = day.format('YYYY-MM-DD');
    const termineForDay = termine.filter((t) => t.datum.startsWith(dateStr));

    // Prüfe ob Tag in der Vergangenheit liegt
    const today = dayjs().startOf('day');
    const isDisabled = day.isBefore(today);

    return (
        <Badge
            key={day.toString()}
            overlap="circular"
            badgeContent={termineForDay.length > 0 && !isDisabled ? termineForDay.length : undefined}
            sx={{ '& .MuiBadge-badge': { bgcolor: '#3b82f6', color: '#fff' } }}
        >
            <PickersDay
                {...other}
                outsideCurrentMonth={outsideCurrentMonth}
                day={day}
                disabled={isDisabled}
                sx={{
                    bgcolor: termineForDay.length > 0 && !isDisabled ? 'rgba(59, 130, 246, 0.15)' : 'transparent',
                    fontWeight: termineForDay.length > 0 && !isDisabled ? 700 : 400,
                    color: '#e0f2fe',
                    ...(isDisabled && {
                        opacity: 0.5,
                        cursor: 'not-allowed',
                    }),
                }}
            />
        </Badge>
    );
}

export default ServerDay;
